import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/styles/makeStyles';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from "@material-ui/core/Typography";
import { Divider } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { TbShoppingCart } from "react-icons/tb";
import SegmentationGraph from './segmentationGraph';
import {useGlobalState} from '../../../state';




const useStyles = makeStyles(theme => ({
    loaderGrid: {
        verticalAlign: 'middle',
        borderRight: '1px solid #bfbfbf',
        padding: theme.spacing(2),
        textAlign: 'center',
        display: 'table-cell'
    },
    card: {
        minHeight: '100%',
        minWidth: '94%',
        marginTop: theme.spacing(2),
        display: 'table',
        width: '98.5%',
        tableLayout: 'fixed'
    },
    rowList: {
        [theme.breakpoints.up('md')]: {
            height: 240,
            maxHeight: 240,
            flexWrap: 'nowrap',
            overflowY: 'auto',
            overflowX: 'hidden',
            width: `calc(100% + ${theme.spacing(2)}px)`,
            margin: theme.spacing(0, -1),
            padding: theme.spacing(0, 1),
            '& > *': {
                flexShrink: 0
            }
        }
    },
    statRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1, 0),
        marginTop: 1,
        '& .MuiTypography-root': {
            color: "black",
        },
    },
    iconBg: {
        width: 36,
        height: 36,
        borderRadius: 8,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    totalRow: {
        backgroundColor: '#f5f6f7',
        borderRadius: 8,
        padding: theme.spacing(1.5, 1),
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(-1),
        marginRight: theme.spacing(-1),
        '& .MuiTypography-root': {
            fontWeight: 800,
            color: "black",
        },
    },
    statValue: {
        marginLeft: 'auto',
        fontWeight: 600,
        textAlign: 'right'
    }
}));



const Purchases = ({ purchaseSegmentationGraphLoading, purchaseSegmentationGraph }) => {
    const theme = useTheme();

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });
    const [{user}] = useGlobalState();
    const [showChart, setShowChart] = React.useState(false);
    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }



    return <>
        {purchaseSegmentationGraphLoading ?
            <Card className={classes.card}>
                <Grid className={classes.loaderGrid} item xs={12}>
                    <CircularProgress className={classes.progressBar} />
                </Grid>
            </Card>
            :
            <Card className={classes.card}>
                <CardHeader title="Purchases" className={classes.header}
                    action={
                        <IconButton size='small' aria-label={showChart ? 'hide chart' : 'show chart'} onClick={() => setShowChart(!showChart)}>
                            {showChart ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    } />
                <Collapse in={showChart}>
                    <Divider />
                    <CardContent>
                        <SegmentationGraph data={purchaseSegmentationGraph.data}
                            label={purchaseSegmentationGraph.label} legendProp={false} />
                    </CardContent>
                </Collapse>
                <Divider />
                <CardActions style={{
                    paddingLeft:"1rem",
                    paddingRight:"1rem",
                }}>
                    <div style={{ width: '100%' }}>
                    <Grid container direction='column' className={classes.rowList}>
                        {Object.keys(purchaseSegmentationGraph.materialTypeMap).map((name, key) => (
                            <React.Fragment key={key}>
                            {key > 0 && <Divider />}
                            <div className={classes.statRow}>
                                <div className={classes.iconBg} style={{ background: '#eaf4fb' }}>
                                    <TbShoppingCart color='#2980b9' size={20} />
                                </div>
                                <Typography>
                                    {name}
                                </Typography>
                                <Typography className={classes.statValue} variant="h5" component="h2">
                                    {purchaseSegmentationGraph.materialTypeMap[name].toLocaleString(user.locales,amountObj)}
                                </Typography>
                            </div>
                            </React.Fragment>
                        ))}
                    </Grid>
                        <Divider />
                        <div className={`${classes.statRow} ${classes.totalRow}`}>
                            <Typography>
                                Total Purchases
                            </Typography>
                            <Typography className={classes.statValue} variant="h5" component="h2">
                                {Object.values(purchaseSegmentationGraph.materialTypeMap).reduce((sum, value) => sum + value, 0).toLocaleString(user.locales,amountObj)}
                            </Typography>
                        </div>
                    </div>
                </CardActions>
            </Card>
        }
    </ >
};


export default Purchases;